import {Component, OnInit, ViewChild} from '@angular/core';
import Swal from 'sweetalert2';
import {take, tap} from 'rxjs/operators';

import { BusinessProcess } from '../../../Models/businessProcess';
import { BusinessProcessService } from '../../../services/business-process.service';
import { GenericModalService } from '../../../services/generic-modal.service';
import { PaginationInstance } from 'ngx-pagination';
import { WebClientConfigurationService } from '../../../services/configuration/web-client-configuration.service';
import { ConsolidationModalComponent } from './consolidation-modal/consolidation-modal.component';
import { Utils } from '../../../services/utils';
import { HttpEventType } from '@angular/common/http';
import {WfTableComponent} from '../../../common/table-sort/wf-table.component';
import {ImportComponent} from './import/import.component';
import {BsModalRef} from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-business-process-list',
  templateUrl: './business-process-list.component.html',
  styleUrls: ['./business-process-list.component.css']
})
export class BusinessProcessListComponent implements OnInit {

  utilsFunctions = Utils;
  businessProcesses: BusinessProcess[];
  filterText: string;
  onlyValid: boolean;
  isSearching = false;
  pleaseWait = false;
  config: PaginationInstance;
  @ViewChild(WfTableComponent, { static: false }) wfDataTable: WfTableComponent;

  hasBusinessProcessRelationshipRight = false;
  hasHistoryReportConfigRight = false;
  hasDesignProcessRight = false;

  pageIndex = 1;
  itemsPerPage = 1;
  totalItems = 1;

  constructor(
    private bpService: BusinessProcessService,
    private modalService: GenericModalService,
    private webClientConfig: WebClientConfigurationService, public bsModalRef: BsModalRef
  ) { }

  ngOnInit() {
    this.checkRights();
    this.bpService.getAllBusinessProcesses().subscribe(result => {
      this.businessProcesses = result;
      this.totalItems = result.length;
      this.getPageIndex(this.pageIndex, result.length);
    }, error1 => this.modalService.showErrorMessage(error1, true) );

  }

  checkRights() {
    this.checkRightsRelationShip();
    this.checkRightsHistoryReportConfig();
    this.checkRightsDesignProcess();
  }

  checkRightsRelationShip() {
    this.bpService.checkRights(16384).subscribe(s => {
      this.hasBusinessProcessRelationshipRight = s.length > 0;
    }, error1 => {
      this.modalService.showErrorMessage(error1, true);
    });
  }

  checkRightsHistoryReportConfig() {
    this.bpService.checkRights(65536).subscribe(s => {
      this.hasHistoryReportConfigRight = s.length > 0;
    }, error1 => {
      this.modalService.showErrorMessage(error1, true);
    });
  }

  checkRightsDesignProcess() {
    this.bpService.checkRights(128).subscribe(s => {
      this.hasDesignProcessRight = s.length > 0;
    }, error1 => {
      this.modalService.showErrorMessage(error1, true);
      console.error(error1);
    });
  }

  formatStatus(valid: number) {
    switch (valid) {
      case 1: return 'Válido';
      break;

      case 0: return 'Inválido';
      break;

      default: return 'Não identificado';
      break;
    }
  }

  checkValidation(bp: BusinessProcess) {
    return (bp.validity === 2 && bp.version === 1) || (bp.validity !== 2);
  }

  checkTooltipValidation(bp: BusinessProcess) {
    if (bp.validity !== 2 && bp.version !== 1) {
      return 'O processo de negócio já foi validado';
    }
  }

  checkPublication(bp: BusinessProcess) {
    return (bp.version === bp.publishedVersion) || (bp.validity !== 1);
  }

  checkTooltipPublication(bp: BusinessProcess) {
    if (bp.validity === 2) {
      return 'É necessário validar o processo de negócio antes de publicar';
    }
    if (bp.version === bp.publishedVersion) {
      return 'Versão publicada refere-se à versão mais recente';
    } else {
      return bp.validationDescription;
    }
  }

  deleteBusinessProcess(businessProcessId) {
    let alert: any;
    this.pleaseWait = true;
    alert = this.modalService
      .showConfirmModal('Confirmação de Exclusão', 'Confirma a exclusão?');

    alert.then((result) => {
      if (result.value) {
        this.bpService.businessProcessActions(businessProcessId, 'Delete').pipe(take(1))
          .subscribe( () => {
            this.pleaseWait = false;
            this.modalService.showSuccessMessage('Exclusão realizada com sucesso', false, 2000);
            this.getItemsPageLength();

            setTimeout(() => {
              this.ngOnInit();
            }, 2000);
          }, error1 => {
            this.pleaseWait = false;
            this.modalService.showErrorMessage(error1, true);
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        this.pleaseWait = false;
      }
    });
  }

  consolidateBusinessProcess(businessProcessId, businessProcessName) {
    const destComponent: any = ConsolidationModalComponent;
    const result$ = this.modalService.showModal(destComponent, 'Histórico de Modificações', businessProcessId, businessProcessName);
    result$.asObservable()
      .pipe(take(1))
      .subscribe(result => {
        if (result) {
          setTimeout(() => {
            this.ngOnInit();
          }, 2000);
        }
      }, error1 => this.modalService.showErrorMessage(error1, true));
  }

  validateBusinessProcess(businessProcessId) {
    this.pleaseWait = true;
    this.bpService.businessProcessActions(businessProcessId, 'Validate').pipe(take(1))
      .subscribe( () => {
        this.pleaseWait = false;
        this.modalService.showSuccessMessage('Processo de negócio validado com sucesso', false, 2000);

        setTimeout(() => {
          this.ngOnInit();
        }, 2000);
      }, error1 => {
        this.pleaseWait = false;
        this.modalService.showErrorMessage(error1, true);
      });
  }

  publishBusinessProcess(businessProcessId) {
    this.pleaseWait = true;

    const alert = this.modalService
      .showConfirmModal('Confirmação de Publicação', 'Confirma a publicação?');
    alert.then((result) => {
      if (result.value) {
        this.bpService.businessProcessActions(businessProcessId, 'Publish').pipe(take(1))
          .subscribe( () => {
            this.pleaseWait = false;
            this.modalService.showSuccessMessage('Processo de negócio publicado com sucesso', false, 2000);
            setTimeout(() => {
              this.ngOnInit();
            }, 2000);
          }, error1 => {
            this.pleaseWait = false;
            this.modalService.showErrorMessage(error1, true);
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        this.pleaseWait = false;
      }
    });
  }

  getPaginationConfig(_currentPage: number, _totalItems: number) {
    this.webClientConfig.getPageSizeConfig().subscribe(item => {
      this.config  = {
        id: 'custom',
        itemsPerPage: item,
        currentPage: this.pageIndex,
        totalItems: _totalItems
      };
      this.itemsPerPage = item;
      this.totalItems = _totalItems;
    }, error1 => this.modalService.showErrorMessage(error1, true));
  }

  getPageIndex(page, totalItems = this.totalItems) {
    this.pageIndex = page;
    this.getPaginationConfig(page, totalItems);
  }

  getItemsPageLength() {
    const totalItemsCount = this.totalItems;
    const itemsPerPage = this.itemsPerPage;
    const page = this.pageIndex;
    let start = (page * itemsPerPage) - (itemsPerPage - 1);
    let end = Math.min(start + itemsPerPage - 1, totalItemsCount);
    if (start == end) {
      this.pageIndex -= 1;
      // devo voltar 1 pagina;
    }
  }

  filterData() {
    let filteredArray = [];
    const emptyFilter = (this.businessProcesses && this.businessProcesses.length === 0)
      || this.filterText === undefined || this.filterText.trim() === '';
    if (emptyFilter && !this.onlyValid) {
      // return this.businessProcesses;
      filteredArray = this.businessProcesses;
    }
    if (emptyFilter && this.onlyValid) {
      /*return this.businessProcesses.filter((v) => {
        return v.validity === 1;
      });*/
      filteredArray = this.businessProcesses.filter((v) => {
        return v.validity === 1;
      });
    }
    if (!emptyFilter && this.onlyValid) {
      // return this.businessProcesses.filter((v) => {
      //   return (v.name.toLowerCase().indexOf(this.filterText.toLowerCase()) >= 0 && v.validity === 1);
      // });
      filteredArray = this.businessProcesses.filter((v) => {
        return (v.name.toLowerCase().indexOf(this.filterText.toLowerCase()) >= 0 && v.validity === 1);
      });
    }
    if (!emptyFilter && !this.onlyValid) {
      // return this.businessProcesses.filter((v) => {
      //   return (v.name.toLowerCase().indexOf(this.filterText.toLowerCase()) >= 0);
      // });
      filteredArray = this.businessProcesses.filter((v) => {
        return (v.name.toLowerCase().indexOf(this.filterText.toLowerCase()) >= 0);
      });
    }
    if (this.config) {
      if ((!emptyFilter || this.onlyValid) && this.isSearching) {
        // se estiver realizando o filtro ou marcando a opção para mostrar somente válidos:

        /*devo considerar como falso o isSearching, para que seja possível continuar navegando na paginação
        sem problemas*/
        this.isSearching = false;
        // devo definir a primeira página como a página atual
        this.config.currentPage = 1;
      }
      this.config.totalItems = this.totalItems = filteredArray.length;
    }
    return filteredArray;
  }

  enableSearching() {
    // identificar se a mudança do filterData() vem dos mecanismos de filtro ou mudança da paginação
    this.isSearching = true;
  }

  exportBusinessProcess(businessProcessId, businessProcessName) {
    this.bpService.exportBusinessProcess(businessProcessId, businessProcessName).subscribe(
      data => {
        switch (data.type) {
          case HttpEventType.DownloadProgress:
            console.log('Exportação status: ' + Math.round((data.loaded / data.total) * 100) + '%');
            break;
          case HttpEventType.Response:
            const downloadedFile = new Blob([data.body], { type: data.body.type });
            const a = document.createElement('a');
            a.setAttribute('style', 'display:none;');
            document.body.appendChild(a);
            a.download = encodeURIComponent(businessProcessName + '.bp');
            a.href = URL.createObjectURL(downloadedFile);
            a.target = '_blank';
            a.click();
            document.body.removeChild(a);
            break;
        }
      },
      error1 => {
        const errorMsg = `Erro ao realizar a exportação do processo de negócio: ${error1}`;
        this.modalService.showErrorMessage(errorMsg, true);
      }
    );
  }

  onImport() {
    const destComponent: any = ImportComponent;
    const result$ = this.modalService.showModal(destComponent, 'Importação do Processo de Negócio');
    result$.asObservable()
      .pipe(take(1))
      .subscribe(result => {
        if (result) {
          setTimeout(() => {
            // tratamento para enviar a última pagina quando for nova fila, para que atualize corretamente
            let totalPages = Math.ceil(this.totalItems / this.itemsPerPage);
            let totalItems = this.totalItems / this.itemsPerPage;
            // verificar se o valor sem arredondamento é menor que o valor arredondado
            // se for menor, quer dizer que ainda estará nesta página, caso contrário, deverá estar na próxima página
            this.pageIndex = totalItems < totalPages ? totalPages : totalPages + 1;
            this.ngOnInit();
          }, 2000);
        }
      });
  }


}
